import { axios } from '../../lib/axios'

import { RegisterCredentialsDTO, RegisterResponse } from './types'

export const registerWithEmailAndPassword = (
  data: RegisterCredentialsDTO,
): Promise<RegisterResponse> => {
  return axios.post('/signup', data)
}
